import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const StaffLedger = () => {
  const [teachers, setTeachers] = useState([]); // State for teachers
  const [searchName, setSearchName] = useState(''); // State for search by name
  const [searchType, setSearchType] = useState(''); // State for search by type
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling
  const navigate = useNavigate(); // Initialize the navigate function
  const [staffType, setStaffType] = useState("teacher"); // teacher | non-teaching

  // Get sessionId from localStorage
  const sessionId = localStorage.getItem('currentSessionId');

useEffect(() => {
  const fetchStaffMembers = async () => {
    if (!sessionId) {
      setError("Session ID not found in localStorage.");
      setLoading(false);
      return;
    }

    try {
      const url =
        staffType === "teacher"
          ? `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers?sessionId=${sessionId}`
          : `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getAllNonTeachingStaff?sessionId=${sessionId}`;

      const response = await axios.get(url);
      setTeachers(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchStaffMembers();
}, [sessionId, staffType]);


  // Filtering the staff members based on search criteria
const filteredTeachers = teachers.filter((staff) => {
  const fullName = staff.firstName
    ? `${staff.firstName} ${staff.lastName || ""}`.toLowerCase()
    : (staff.name || "").toLowerCase();

  return fullName.includes(searchName.toLowerCase());
});

    // const teacherType = teacher.teacherType ? teacher.teacherType.toLowerCase() : '';

    // return fullName.includes(searchName.toLowerCase()) &&
    //        (teacherType.includes(searchType.toLowerCase()) || searchType === '');
  // });

  const viewStaffLedger = (id) => {
    navigate(`/ledgerStaffId/${id}`); // Navigate to the staff ledger page
  };

  const advanceStaff = (id) => {
    navigate(`/advance-staff/${id}?type=${staffType}`); // Navigate to the staff advance page
  };

  // Loading and error handling
  if (loading) {
    return <div className="flex justify-center items-center h-64">Loading...</div>; // Centered loading spinner
  }

  if (error) {
    return <div className="text-red-500">Error: {error}</div>; // Show error state with red text
  }

  const formatClassIncharge = (val) => {
    if (!val) return "--";
    return val.replace(/\s|-/g, ""); 
  };

  return (
    <div className="p-6 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-6">
          <div className="mb-4">
  <select
    value={staffType}
    onChange={(e) => {
      setStaffType(e.target.value);
      setSearchName("");
    }}
    className="p-3 border rounded shadow-md focus:ring-2 focus:ring-blue-500"
  >
    <option value="teacher">Teacher</option>
    <option value="non-teaching">Non-Teaching Staff</option>
  </select>
</div>

          {/* Search Section */}
          <div className="flex flex-col md:flex-row justify-between items-center mb-6">
            <div className="w-full md:w-1/2">
              <input
                type="text"
                placeholder="Search by Name"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                className="p-3 border border-gray-300 rounded w-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="mt-4 md:mt-0 text-center md:text-left">
              <div className="inline-flex items-center bg-blue-100 text-blue-700 rounded px-4 py-2">
                <i className="fas fa-chalkboard-teacher text-2xl mr-2"></i>
                <p className="text-lg font-semibold">Total Teachers: {filteredTeachers.length}</p>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border-collapse border border-gray-300 rounded-lg shadow-lg">
<thead className="bg-blue-50">
  <tr>
    <th className="py-3 px-4 border-b">Sr No.</th>
    <th className="py-3 px-4 border-b">Name</th>

    {staffType === "teacher" && (
      <>
        <th className="py-3 px-4 border-b">Subject</th>
        <th className="py-3 px-4 border-b">Class Incharge</th>
      </>
    )}

    <th className="py-3 px-4 border-b">Actions</th>
  </tr>
</thead>

              <tbody>
                {filteredTeachers.map((staff, index) => (
  <tr
    key={staff._id}
    className="bg-white text-center hover:bg-gray-100 transition-all duration-200 ease-in-out"
  >
    <td className="py-3 px-4 border-b">{index + 1}</td>

    {/* ✅ NAME */}
    <td className="py-3 px-4 border-b">
      {staffType === "teacher"
        ? `${staff.firstName} ${staff.lastName}`
        : staff.name}
    </td>

    {/* ✅ SUBJECT (TEACHER ONLY) */}
    {staffType === "teacher" && (
      <td className="py-3 px-4 border-b">
        {Array.isArray(staff.subjectYouTeach)
          ? staff.subjectYouTeach.flatMap((item) => {
              try {
                return JSON.parse(item);
              } catch {
                return item;
              }
            }).join(", ")
          : ""}
      </td>
    )}

    {/* ✅ CLASS INCHARGE (TEACHER ONLY) */}
    {staffType === "teacher" && (
      <td className="py-3 px-4 border-b">
        {formatClassIncharge(staff.classIncharge)}
      </td>
    )}

    {/* ✅ ACTIONS (SAME FOR BOTH) */}
    <td className="py-3 px-4 border-b">
      <div className="flex justify-center space-x-2">
        <button
          onClick={() => viewStaffLedger(staff._id)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-400 flex items-center"
          title="View Ledger"
        >
          <i className="fas fa-book mr-1"></i> Ledger
        </button>

        <button
          onClick={() => advanceStaff(staff._id)}
          className="px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-400 flex items-center"
          title="Advance Payment"
        >
          <i className="fas fa-money-bill mr-1"></i> Advance
        </button>
      </div>
    </td>
  </tr>
))}

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffLedger;
